import {StyleSheet, css} from 'aphrodite';
import classNames from 'classnames';
import React from 'react';

import {getActionButtonRoleProps} from 'lib/a11y/ButtonA11y';
import {GRAY} from 'ui-library/Colors';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

export default function AddSampleTypeButton({
  onClick,
  isDisabled,
}: {
  onClick: () => void;
  isDisabled: boolean;
}): JSX.Element {
  return (
    <BenchlingIcon
      aria-disabled={isDisabled}
      aria-label="Add sample type"
      className={classNames('simpleDivTable-addButton', {
        [css(styles.disabled)]: isDisabled,
      })}
      {...getActionButtonRoleProps({onPress: onClick})}
      icon="compose"
    />
  );
}

const styles = StyleSheet.create({
  disabled: {
    color: GRAY,
    cursor: 'default',
    pointerEvents: 'none',
  },
});
